export default "__VITE_ASSET__C0Mdn5Zw__"